module.exports = __webpack_public_path__ + "img/logo-sozialdienste.c2808c8f.png";